import { ClickableIcon } from "@portal/components/primitives/ClickableIcon";
import { Text } from "@portal/components/primitives/Text";
import { FC } from "react";

export type SectionHeaderWithAddProps = {
	title: string;
	onAdd: () => void;
	addLabel?: string;
	testId?: string;
};

export const SectionHeaderWithAdd: FC<SectionHeaderWithAddProps> = ({
	title,
	addLabel,
	onAdd,
	testId,
}) => (
	<div className="flex items-center gap-[8px]">
		<Text type="heading" color="primary">
			{title}
		</Text>
		<ClickableIcon
			data-testid={testId}
			aria-label={addLabel ?? "Add"}
			type="plus"
			size="mini"
			color="secondary"
			filled
			onClick={onAdd}
		/>
	</div>
);
